export const HIGHLIGHT_CSS_VARS = [
  "--primary",
  "--background",
  "--foreground",
  "--sidebar-primary",
  "--chat-box",
  "--radius",
] as const

// Every token in customer/config.json's palette, in its order, so ink/tint sit
// next to their fill. branding-config-constants.test.ts fails if the two drift.
export const DEFAULT_CSS_VAR_NAMES = [
  "--background",
  "--foreground",
  "--card",
  "--card-foreground",
  "--popover",
  "--popover-foreground",
  "--primary",
  "--primary-foreground",
  "--primary-ink",
  "--primary-tint",
  "--secondary",
  "--secondary-foreground",
  "--muted",
  "--muted-foreground",
  "--accent",
  "--accent-foreground",
  "--destructive",
  "--destructive-foreground",
  "--destructive-ink",
  "--warning",
  "--warning-foreground",
  "--warning-ink",
  "--success",
  "--success-foreground",
  "--success-ink",
  "--border",
  "--input",
  "--ring",
  "--chart-1",
  "--chart-2",
  "--chart-3",
  "--chart-4",
  "--chart-5",
  "--chart-foreground",
  "--sidebar-background",
  "--sidebar-foreground",
  "--sidebar-primary",
  "--sidebar-primary-foreground",
  "--sidebar-accent",
  "--sidebar-accent-foreground",
  "--sidebar-border",
  "--sidebar-ring",
  "--scrollbar-track",
  "--scrollbar-thumb",
  "--scrollbar-thumb-hover",
  "--radius",
  "--chat-box",
] as const

export const BRANDING_ASSET_SLOTS: {
  key: string
  labelKey: string
  labelFallback: string
  accept: string
}[] = [
  {
    key: "logo_small_light",
    labelKey: "adminDashboard.branding.assets.logoSmallLight",
    labelFallback: "Small logo (light)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "logo_small_dark",
    labelKey: "adminDashboard.branding.assets.logoSmallDark",
    labelFallback: "Small logo (dark)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "logo_large_light",
    labelKey: "adminDashboard.branding.assets.logoLargeLight",
    labelFallback: "Large logo (light)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "logo_large_dark",
    labelKey: "adminDashboard.branding.assets.logoLargeDark",
    labelFallback: "Large logo (dark)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "logo_landing_light",
    labelKey: "adminDashboard.branding.assets.logoLandingLight",
    labelFallback: "Home / landing logo (light)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "logo_landing_dark",
    labelKey: "adminDashboard.branding.assets.logoLandingDark",
    labelFallback: "Home / landing logo (dark)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "favicon_light",
    labelKey: "adminDashboard.branding.assets.faviconLight",
    labelFallback: "Favicon (light)",
    accept: "image/png,image/x-icon,image/vnd.microsoft.icon,image/svg+xml,.ico",
  },
  {
    key: "favicon_dark",
    labelKey: "adminDashboard.branding.assets.faviconDark",
    labelFallback: "Favicon (dark)",
    accept: "image/png,image/x-icon,image/vnd.microsoft.icon,image/svg+xml,.ico",
  },
  {
    key: "assistant_avatar_light",
    labelKey: "adminDashboard.branding.assets.assistantAvatarLight",
    labelFallback: "Assistant avatar (light)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "assistant_avatar_dark",
    labelKey: "adminDashboard.branding.assets.assistantAvatarDark",
    labelFallback: "Assistant avatar (dark)",
    accept: "image/png,image/jpeg,image/webp,image/svg+xml",
  },
  {
    key: "pwa_icon_180",
    labelKey: "adminDashboard.branding.assets.pwa180",
    labelFallback: "PWA icon 180×180 (PNG)",
    accept: "image/png",
  },
  {
    key: "pwa_icon_192",
    labelKey: "adminDashboard.branding.assets.pwa192",
    labelFallback: "PWA icon 192×192 (PNG)",
    accept: "image/png",
  },
  {
    key: "pwa_icon_512",
    labelKey: "adminDashboard.branding.assets.pwa512",
    labelFallback: "PWA icon 512×512 (PNG)",
    accept: "image/png",
  },
]
